import React, { useEffect } from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { breadcrumbs } from 'constants/routes';
import BreadcrumbMenu from 'containers/Breadcrumb';
import Page from 'containers/Page';
import RouteForm from 'containers/Route/Form';
import { ContentRoutes } from 'enums/routes';
import { AccessTypes, MethodTypes } from 'enums/types';
import { policy } from 'polices';

export default function NewRoute() {
  const policies = policy('routes');
  const { push } = useHistory();

  useEffect(() => {
    if (policies(MethodTypes.View) === AccessTypes.Disallow) {
      push('/403');
    }
  }, []);

  return (
    <Page>
      <Flex
        maxW="1024px"
        mx="auto"
        w="100%"
        pr={5}
        py={8}
        pl={10}
        flexDirection="column">
        <BreadcrumbMenu paths={[
          ...breadcrumbs[ContentRoutes.Routes], {
            path: `/${ContentRoutes.Routes}`,
            label: 'Nova Rota',
          },
        ]}
        />
        <Text
          mt={2}
          color="gray.700"
          variant="3xLargeBold">NOVA ROTA
        </Text>
        <RouteForm />
      </Flex>
    </Page>
  );
}
